export default __webpack_public_path__ + "src/images/galleries/1/btn_lan_preface_cn-23db87.png";